import React from 'react';
import PropTypes from 'prop-types';
import MediaQueries from 'react-responsive';

import Align from '@marvelapp/marvel-ui/align';
import Grid, { GridItem } from '@marvelapp/marvel-ui/grid';
import PageWrap from '@marvelapp/marvel-ui/page-wrap';
import Spacing from '@marvelapp/marvel-ui/spacing';
import Heading from '@marvelapp/marvel-ui/heading';
import Paragraph from '@marvelapp/marvel-ui/paragraph';
import MaxWidth from '@marvelapp/marvel-ui/max-width';

import Image from 'marketing-website/components/modules/Image';
import MediaMultipleImages from 'marketing-website/components/modules/Media/MediaMultipleImages';
import ParallaxWrapper from 'marketing-website/components/wrappers/ParallaxWrapper';
import Pattern from 'marketing-website/components/commons/Pattern';
import Shape from 'marketing-website/components/commons/Shape';

import assets from 'marketing-website/configs/pages/features/design/assets.js';

export default function DesignBlock({ color }) {
  return (
    <PageWrap size="l">
      <Spacing size="xl" type="padding" position="topBottom">
        <Grid columns={12} alignItems="center">
          <GridItem columnSpan={12} columnSpanM={6}>
            <Align type="center">
              <MediaQueries maxWidth={769}>
                <Spacing size="l" type="padding" position="bottom">
                  <Image {...assets.typographyFallback} hasShadow={false} />
                </Spacing>
              </MediaQueries>
            </Align>
            <Align type="center" typeM="left">
              <MaxWidth value={500} display="inlineBlock">
                <Heading size="xxxl" weight="semibold">
                  A design tool in your browser
                </Heading>
              </MaxWidth>
              <MaxWidth value={500} display="inlineBlock">
                <Spacing type="margin" size="s" position="topBottom">
                  <Paragraph size="l">
                    We built our online design platform with everyone in mind;
                    as a result we created a simple and intuitive design tool
                    which enables everyone to quickly create beautiful assets
                    and mockups. There’s no learning curve and no software
                    required, so everyone can get involved.
                  </Paragraph>
                </Spacing>
              </MaxWidth>
            </Align>
          </GridItem>
          <GridItem columnSpan={12} columnSpanM={6}>
            <MediaQueries minWidth={770}>
              <MediaMultipleImages
                fallbackImageAlt="design_design_fallback"
                fallbackImageSrc={assets.typographyFallback.src}
                fallbackImageMaxWidth={assets.typographyFallback.maxWidth}
              >
                <Shape type="losange" color={color} />
                <ParallaxWrapper speed={1}>
                  <Pattern
                    color="yellow"
                    left="auto"
                    right="30%"
                    top="auto"
                    bottom="15%"
                    type="fish"
                  />
                </ParallaxWrapper>
                <ParallaxWrapper>
                  <Image
                    {...assets.fonts}
                    borderRadius="l"
                    left="16%"
                    maxWidth={312}
                    position="absolute"
                    top="30%"
                  />
                </ParallaxWrapper>
                <ParallaxWrapper speed={1.7}>
                  <Image
                    {...assets.input}
                    borderRadius="m"
                    left="14%"
                    maxWidth={336}
                    position="absolute"
                    top="24%"
                  />
                </ParallaxWrapper>
              </MediaMultipleImages>
            </MediaQueries>
          </GridItem>
        </Grid>
      </Spacing>
    </PageWrap>
  );
}

DesignBlock.propTypes = {
  color: PropTypes.string,
};

DesignBlock.defaultProps = {
  color: null,
};



// WEBPACK FOOTER //
// ./src/pages/features/design/DesignBlock.js